<template>
  <div class="candidates">
    <div>

      <div class="return">
        当前位置：<span @click="goBack" class="back">首页</span> <span>></span><span class="blue"> 上传体检报告</span>
      </div>

      <div class="box">
        <div class="img" v-if="infoList.status||infoList.status==0">
          <img v-if="infoList.status==2" src="../../assets/image/wait.png" alt="" srcset="">
          <img v-if="infoList.status==1" src="../../assets/image/pass.png" alt="" srcset="">
          <img v-if="infoList.status==0&&isModify" src="../../assets/image/nopass.png" alt="" srcset="">
        </div>
        <h2>
          浙江中医药大学推免生体检报告上传
        </h2>
        <div class='p'>
          上传时间： <span v-if="!isOpen">未开始！</span><span v-else>{{time.startTime}}至{{time.endTime}}</span>

        </div>
        <el-form ref="form" :model="form" label-width="140px" class="left">
          <el-form-item label="姓名:">
            <span class="span">{{infoList.xm}}</span>
          </el-form-item> <el-form-item label="性别:">
            <span class="span">
              <span v-if="infoList.xbm=='1'">男</span>
              <span v-if="infoList.xbm=='2'">女</span>
            </span>
          </el-form-item> <el-form-item label="身份证号:">
            <span class="span">{{infoList.zjhm}}</span>
          </el-form-item> <el-form-item label="移动电话:">
            <span class="span">{{infoList.lxdh}}</span>
          </el-form-item>

          <el-form-item label="上传体检报告:" required v-if="!isSubmit&&!infoList.status&&infoList.status!='0'">
            <span>请上传一个PDF文件：包括体检表、化验单和检查单</span>
          </el-form-item>

          <el-form-item label="上传体检报告:" v-else-if="infoList.status">
            <span class="fj" @click="open(infoList.fj.url)">{{infoList.fj.fileName}}</span>
          </el-form-item>
          <el-form-item label="上传体检报告:" v-else-if="infoList.status==0&&isModify">
            <span class="fj" @click="open(infoList.fj.url)">{{infoList.fj.fileName}}</span>
          </el-form-item>
          <el-form-item label="上传体检报告:" required v-else-if="infoList.status==0&&!isModify">
            <span>请上传一个PDF文件：包括体检表、化验单和检查单</span>
          </el-form-item>
          <el-form-item size="large" v-if="!isSubmit&&!infoList.status&&infoList.status!='0'">

            <el-upload class="upload-demo" :action="upload" :data="uploadData" :limit="1" accept=".pdf,.PDF" :before-upload="handlebefore" :on-success="handleSuccess" ref="uploadcsv">
              <el-button size="medium" type="primary" plain >+上传附件</el-button>

            </el-upload>
            <div>
              <li v-for="(item, index) in fileList">
                <i class="el-icon-document"></i><span style="margin-right:20px;margin-left:10px" class="blue" @click="open(item.url)">{{ item.fileName }}</span><i class="el-icon-close" @click="cancelupload(index, item.id)"></i>
              </li>
            </div>
          </el-form-item>
          <el-form-item size="large" v-else-if="infoList.status==0&&!isModify">

            <el-upload class="upload-demo" :action="upload" :data="uploadData" :limit="1" accept=".pdf,.PDF" :before-upload="handlebefore" :on-success="handleSuccess" ref="uploadcsv">
              <el-button size="medium" type="primary" plain>+上传附件</el-button>

            </el-upload>
            <div>
              <li v-for="(item, index) in fileList">
                <i class="el-icon-document"></i><span style="margin-right:20px;margin-left:10px" class="blue" @click="open(item.url)">{{ item.fileName }}</span><i class="el-icon-close" @click="cancelupload(index, item.id)"></i>
              </li>
            </div>
          </el-form-item>

          <el-form-item v-if="infoList.content&&infoList.status==0" style="color:red !important">
            <template slot="label">
              <span style="color:red !important">退回原因:</span>
            </template>
            <span class="span">{{infoList.content}}</span>
          </el-form-item>
        </el-form>
      </div>
      <div class="sub">
        <el-button type="primary" class="subBtn" @click="submitUpload(1)" v-if="!infoList.status&&infoList.status!='0'" :disabled="!isOpen&&!infoList.status">提交</el-button>
        <el-button type="primary" class="subBtn" @click="modifyClick" v-if="infoList.status==0&&isModify">修改</el-button>
        <el-button type="primary" class="subBtn" @click="submitUpload(2)" v-if="infoList.status==0&&!isModify">提交</el-button>
      </div>
    </div>

  </div>

  </div>
</template>

<script>
// import Breadcrumb from "@/components/common/Breadcrumb.vue";
export default {
  data() {
    return {
      upload: "/api_unpush/systemUpload/upload",
      uploadData: {
        file: "",
      },
      fileList: [],
      form: {},
      isOpen: false,
      time: "",
      infoList: {},
      isSubmit: false,
      isModify: true,
    };
  },
  methods: {
    getTime() {
      // /zsMedical/checkMedical
      this.$http.get("/zsMedical/checkMedical").then((res) => {
        const data = res.data.data;
        this.isOpen = data;
        if (data) {
          this.$http.get("/zsMedical/time").then((res) => {
            const data = res.data.data;
            this.time = data;
          });
        }
      });
    },
    getInfo() {
      this.$http.get("/zsMedical/selectInfo").then((res) => {
        const data = res.data.data;
        this.infoList = data;
        if (this.infoList.status == "0") {
          this.fileList[0] = data.fj;
        }
        console.log(this.fileList);
        console.log(data);
      });
    },

    goBack() {
      this.$router.push("/home");
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },

    beforeRemove(file, fileList) {
      this.fileList = this.fileList.filter((f) => file.name !== f.name);
      // return this.$confirm(`确定移除 ${ file.name }？`);
    },
    handleSuccess(response, file, fileList) {
      console.log(response, file, fileList);
      // this.getInfo()
      // this.$message.success('上传成功')
    },
    modifyClick() {
      this.isModify = false;
      this.fileList[0] = this.infoList.fj;
    },
    submitUpload(type) {
      console.log(this.fileList);
      if (this.fileList.length === 0) {
        return this.$message.error("请上传体检报告!");
      }
      let url = "";
      if (type == 1) {
        url = "/zsMedical/save";
      }
      if (type == 2) {
        url = `/zsMedical/update/${this.infoList.id}`;
      }
      this.$http.post(url, this.fileList[0]).then((res) => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.getTime();

        this.getInfo();
      });
      // this.$refs.upload.submit();
    },
    fileChange(file, fileList) {
      console.log(file, fileList);
    },
    handlebefore(file) {
      console.log(file, "123333333333333333333");
      // this.uploadData.file = file.name;
      const MAX_FILE_COUNT = 1; // 设置最大文件数量

      if (this.fileList.length >= MAX_FILE_COUNT) {
        this.$message.error(`最多只能上传${MAX_FILE_COUNT}个文件`);
        return false; // 返回 false 阻止上传动作
      }

      // this.fileList.push(file); // 将文件添加到 fileList 中
      return true; // 返回 true 允许上传动作
    },
    handleSuccess(file, fileList) {
      this.fileList.push(file.data);
      console.log(file, fileList);

      console.log(this.fileList);

      if (file.code == 400) {
        this.$message({
          message: "上传失败，请重新上传",
          type: "error",
        });
        this.$refs.uploadcsv.clearFiles();
      } else {
        this.$message({
          message: "上传成功",
          type: "success",
        });
        setTimeout(() => {
          this.$refs.uploadcsv.clearFiles();
        }, 500);
      }
    },
    cancelupload(index, id) {
      this.fileList.splice(
        this.fileList.findIndex((item) => item.id === id),
        1
      );
    },
    open(val) {
      window.open(val);
    },
  },
  created() {
    this.isSubmit = this.$store.getters.getLoginData.bgflag;
    console.log(this.isSubmit);
    // console.log(this.$store.getters.getLoginData);
    this.getTime();
    this.getInfo();
  },
};
</script>
this.$router.push("/home");
<style scoped lang="scss">
.return {
  height: 50px;
  line-height: 50px;
  padding-left: 15px;
  // cursor:pointer;
  border-bottom: 1px solid #ccc;
  .back {
    cursor: pointer;
  }
  .blue {
    color: #1890ff;
  }
}
.labels {
  font-size: 1rem /* 16/16 */;
  color: #333;
}
.line {
  color: #333 !important;
}
/* 100/16 */
.subP {
  text-align: center;
  font-size: 1rem /* 16/16 */;
}

.candidates {
  width: 100%;
  height: calc(100% - 72px);

  background: #f2f2f2;
  font-size: 0.875rem /* 14/16 */;
}
/* 40/16 */
.content {
  width: 100%;
  // width: 1500px;
  margin: auto;
  background: #fff;
  padding: 1.25rem /* 20/16 */ 1.25rem /* 20/16 */ 1.875rem /* 30/16 */;
}

.succ {
  width: 100%;
  // width: 1500px;

  background: #fff;
  text-align: center;
  margin: auto;

  img {
    width: 43.75rem /* 700/16 */;
  }

  p {
    font-size: 1.875rem /* 30/16 */;
  }
}

.title {
  width: 100%;
  height: 4.5rem /* 72/16 */;
  background: linear-gradient(
    90deg,
    rgba(24, 144, 255, 1) 0%,
    rgba(24, 144, 255, 1) 0%,
    rgba(136, 199, 255, 1) 100%,
    rgba(136, 199, 255, 1) 100%
  );

  p {
    text-align: center;
    font-size: 1.75rem /* 28/16 */;
    color: #fff;
    line-height: 4.5rem /* 72/16 */;
    font-weight: 700;
  }
}

.success {
  width: 100%;
  text-align: center;

  p {
    font-size: 1.5625rem /* 25/16 */;
    font-weight: 600;
    color: #6ed284;
  }
}

.required:before {
  content: "*";
  color: red;
  margin-right: 0.3125rem /* 5/16 */;
}

.box {
  width: 37.5rem /* 600/16 */;
  // width:100%;
  margin: 1.875rem /* 30/16 */ auto;
  position: relative;

  .img {
    position: absolute;
    right: 0;
    top: 6.375rem /* 70/16 *//* 55/16 */ /* 45/16 */
  }
  .left {
    margin-left: 2.8125rem; /* 45/16 */
  }
  h2 {
    font-weight: 700;
    text-align: center;
    font-style: normal;
    font-size: 1.25rem /* 20/16 */;
    margin-top: 0.9375rem; /* 15/16 */
    margin-bottom: 0.9375rem; /* 15/16 */
  }
  .p {
    // text-align:center;
    margin-left: 7.125rem /* 50/16 */;
    font-size: 1rem /* 16/16 */;
    margin-top: 2.25rem /* 20/16 */; /* 15/16 */
    margin-bottom: 2.25rem; /* 15/16 */
    color: #1890ff;
  }
  .span {
    font-weight: 700;
  }
  .fj {
    color: #1890ff;
    text-decoration: underline;
    cursor: pointer;
  }
}
@media (max-width: 768px) {
  .box {
    // width: 13.75rem /* 220/16 */;
    width: 100%;
    margin: 0;
    // margin: 1.25rem /* 20/16 */ /* 30/16 */ auto;
  }
  /deep/ .dialog-footer {
    display: flex;
  }
  .succ {
    img {
      width: 100%;
    }
  }
  /deep/ .el-input__inner {
    &::placeholder {
      font-size: 1.125rem /* 18/16 */;
    }

    &::-webkit-input-placeholder {
      /* WebKit browsers 适配谷歌 */
      font-size: 1.125rem /* 18/16 */;
    }

    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 适配火狐 */
      font-size: 1.125rem /* 18/16 */;
    }

    &::-moz-placeholder {
      /* Mozilla Firefox 19+ 适配火狐 */
      font-size: 1.125rem /* 18/16 */;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10+  适配ie*/
      font-size: 1.125rem /* 18/16 */;
    }
  }
}
.upload {
  text-align: left;
  margin: 1.25rem /* 20/16 */ 0 p {
    font-size: 0.875rem /* 14/16 */;
    line-height: 1.5625rem /* 25/16 */;
    color: #f64646;
  }

  .uploadBtn {
    margin: 1.25rem /* 20/16 */ 0;
  }
}

.sub {
  width: 100%;
  text-align: center;
  margin: 1.25rem /* 20/16 */ 0;
  padding-bottom: 3.125rem /* 50/16 */;
  margin-bottom: 1.25rem /* 20/16 */;
  .subBtn {
    width: 18.75rem /* 300/16 */;
  }
}
.el-form-item {
  margin-bottom: 1.875rem /* 30/16 */;
}
</style>
